
import Vue from "vue";
import Search from "@/components/Search.vue";
import SubHeader from "@/views/layout/header/SubHeader.vue";
import MenuFooter from "@/views/layout/footer/MenuFooter.vue";
import { Component } from "vue-property-decorator";
import api from "@/api";
import ProgressTicketModel from "@/models/createTicket/ProgressTicketModel";
import CardNotTicket from "@/components/card/CardNotTicket.vue";
import utils from "@/utils";
import { UserModule } from "@/store/modules/user";
import { ValidationObserver, ValidationProvider } from "vee-validate";
@Component({
  components: {
    Search,
    SubHeader,
    MenuFooter,
    CardNotTicket,
    ValidationObserver,
    ValidationProvider,
  },
})
export default class Progress extends Vue {
  mounted() {
    if (this.$route.name === "progress") {
      this.getListProgress(this.$route.params.id);
    }
  }
  utils = utils;
  userDetail = UserModule.userDetail;
  displayList = true;
  titlePage = "Progress";
  isActiveDesc = false;
  countProgressApprove: number | null = 0;
  displayLoading = true;
  displayProgress = false;

  message: string | null = null;

  listProgress: ProgressTicketModel[] = [];
  progress: ProgressTicketModel = new ProgressTicketModel();
  getListProgress(idTicket: string) {
    this.displayLoading = true;
    return new Promise((resolve, reject) => {
      api.ticket
        .getListProgress(idTicket)
        .then((response) => {
          if (response.data.code === 200) {
            this.listProgress = [...response.data.data.progress];
            this.countProgressApprove = this.listProgress.filter(
              (item) => item.progress_status === "approved, ticket close"
            ).length;
            this.displayLoading = false;
            this.displayProgress = true;
            resolve(response);
          }
        })
        .catch((err) => {
          reject(new Error(err));
        });
    });
  }
  getListProgressSearch(idTicket: string | null, search: string | null) {
    this.displayLoading = true;
    return new Promise((resolve, reject) => {
      api.ticket
        .getListProgressSearch(idTicket, search)
        .then((response) => {
          if (response.data.code === 200) {
            this.listProgress = [...response.data.data.progress];
            this.displayLoading = false;
            this.displayProgress = true;
            resolve(response);
          }
        })
        .catch((err) => {
          reject(new Error(err));
        });
    });
  }
  onClickSubmitSearch(value: string | null) {
    this.getListProgressSearch(this.$route.params.id, value);
  }
  approveTicket(idProgress: string) {
    this.$swal({
      text: "Apakah Anda yakin untuk menyetujui progress ini ?",
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonText: "Ya",
      cancelButtonText: "Tidak",
    }).then((result) => {
      if (result.value) {
        const status = "approve";
        this.message = "diterima";
        if (this.userDetail.accessgroup["name"] === "Supervisor") {
          api.ticket
            .approvalProgressSupervisor(
              this.$route.params.id,
              idProgress,
              status,
              this.message
            )
            .then((response) => {
              if (response.data.code === 200) {
                this.$swal(
                  "Berhasil",
                  "Progress Berhasil disetujui",
                  "success"
                );
                this.getListProgress(this.$route.params.id).then(() => {
                  this.message = "";
                });
              } else {
                this.$swal("Peringatan", response.data.message, "warning");
              }
            })
            .catch((err: any) => {
              this.$swal("Error", err?.response?.data?.message, "error");
            });
        } else {
          api.ticket
            .approvalProgressUser(
              this.$route.params.id,
              idProgress,
              status,
              this.message
            )
            .then((response) => {
              if (response.data.code === 200) {
                this.$swal(
                  "Berhasil",
                  "Progress Berhasil disetujui",
                  "success"
                );
                this.getListProgress(this.$route.params.id).then(() => {
                  this.message = "";
                });
              } else {
                this.$swal("Peringatan", response.data.message, "warning");
              }
            })
            .catch((err: any) => {
              this.$swal("Error", err?.response?.data?.message, "error");
            });
        }
      } else {
        this.$swal("Info", "Persetujuan dibatalkan", "info");
      }
    });
  }
  submitReject() {
    if (this.message) {
      this.$swal({
        text: "Apakah Anda yakin untuk menolak progress ini ?",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: "Ya",
        cancelButtonText: "Tidak",
      }).then((result) => {
        if (result.value) {
          const status = "rejected";
          if (this.userDetail.accessgroup["name"] === "Supervisor") {
            api.ticket
              .approvalProgressSupervisor(
                this.$route.params.id,
                this.progress.id,
                status,
                this.message
              )
              .then((response) => {
                if (response.data.code === 200) {
                  this.$swal(
                    "Berhasil",
                    "Progress Berhasil ditolak",
                    "success"
                  );
                  this.getListProgress(this.$route.params.id).then(() => {
                    this.cancelReject();
                  });
                } else {
                  this.$swal("Peringatan", response.data.message, "warning");
                }
              })
              .catch((err: any) => {
                this.$swal("Error", err?.response?.data?.message, "error");
              });
          } else {
            api.ticket
              .approvalProgressUser(
                this.$route.params.id,
                this.progress.id,
                status,
                this.message
              )
              .then((response) => {
                if (response.data.code === 200) {
                  this.$swal(
                    "Berhasil",
                    "Progress Berhasil ditolak",
                    "success"
                  );
                  this.getListProgress(this.$route.params.id).then(() => {
                    this.cancelReject();
                  });
                } else {
                  this.$swal("Peringatan", response.data.message, "warning");
                }
              })
              .catch((err: any) => {
                this.$swal("Error", err?.response?.data?.message, "error");
              });
          }
        } else {
          this.$swal("Info", "Penolakan dibatalkan", "info");
        }
      });
    }
  }
  rejectTicket(item: ProgressTicketModel) {
    this.progress = Object.assign({}, item);
    this.displayList = false;
    this.titlePage = "Detail Ticket";
  }
  cancelReject() {
    this.progress = new ProgressTicketModel();
    this.displayList = true;
    this.titlePage = "Progress";
  }
  cekDesc() {
    if (this.message !== "") {
      this.isActiveDesc = true;
    } else if (this.message === "") {
      this.isActiveDesc = false;
    }
  }
  createProgress() {
    this.$router.push({ path: "/create-progress/" + this.$route.params.id });
  }
  colorStatus(statusColor: string) {
    let color = "";
    switch (statusColor) {
      case "approved":
        color = "approve";
        break;
      case "approved, ticket close":
        color = "approve";
        break;
      case "rejected":
        color = "reject";
        break;
      case "rejected by user":
        color = "reject";
        break;
      case "rejected by supervisor":
        color = "reject";
        break;
      case "waiting approval":
        color = "waiting";
        break;
      case "waiting user approval":
        color = "waiting";
        break;
      case "waiting supervisor approval":
        color = "waiting";
        break;
      default:
        color = "reject";
    }
    return color;
  }
  labelStatus(statusColor: string) {
    let label = "";
    switch (statusColor) {
      case "approve":
        label = "Approved";
        break;
      case "approved, ticket close":
        label = "Approved";
        break;
      case "rejected":
        label = "Rejected";
        break;
      case "rejected by user":
        label = "Rejected By User";
        break;
      case "rejected by supervisor":
        label = "Rejected By Supervisor";
        break;
      case "waiting approval":
        label = "Waiting Approval";
        break;
      case "waiting user approval":
        label = "Waiting User Approval";
        break;
      case "waiting supervisor approval":
        label = "Waiting Supervisor Approval";
        break;
      default:
        label = "Rejected";
    }
    return label;
  }
  isAllowToApprove(progress: ProgressTicketModel) {
    if (
      (this.userDetail.accessgroup["name"] === "User" &&
        progress.progress_status === "waiting approval") ||
      (this.userDetail.accessgroup["name"] === "User" &&
        progress.progress_status === "waiting user approval")
    ) {
      return true;
    } else if (
      (this.userDetail.accessgroup["name"] === "Supervisor" &&
        progress.progress_status === "waiting approval") ||
      (this.userDetail.accessgroup["name"] === "Supervisor" &&
        progress.progress_status === "waiting supervisor approval")
    ) {
      return true;
    } else {
      return false;
    }
  }
}
